import { ToasterProps } from '@/components/shared/snackbar-popup';
import { createStore, stateSetterHandler } from '@muvi/react-common';
import { isDevtoolsEnabled } from '@/logic/state/store-devtools';

export type snackState = {
  snack: ToasterProps;
};

const initState: snackState = {
  snack: {
    isOpen: false,
    message: '',
    type: 'success',
    icon: '',
    id: '',
  },
};

export const useSnack = createStore({
  name: 'snack',
  devtools: isDevtoolsEnabled,
  persist: false,
})(initState, set => {
  const handler = stateSetterHandler(set);
  return {
    setSnack: handler('snack'),
  };
});
